import { INTERSCHEME_INIT_LOADING, INTERSCHEME_INIT_SUCCESS, INTERSCHEME_INIT_FAIL, INTERSCHEME_COMMIT_KEY } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'
import http from '@/utils/ajax'
const state = {
  init: 0,
  initErr: [],
  menu: {},
  interScheme: {
    interSchemeId: {
      inter: null,
      scheme: null,
      defaultSchemeAE: null,
      effDate: null,
      expDate: null,
      createdBy: null,
      createdDate: null,
      modifiedBy: null,
      modifiedDate: null
    }
  }
}

const getters = {
}

const mutations = {
  [INTERSCHEME_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [INTERSCHEME_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [INTERSCHEME_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [INTERSCHEME_COMMIT_KEY](state, data) {
    state.interScheme.interSchemeId.inter = data.inter
    state.interScheme.interSchemeId.scheme = data.scheme
    state.interScheme.interSchemeId.defaultSchemeAE = data.defaultSchemeAE
    state.interScheme.interSchemeId.effDate = data.effDate
    state.interScheme.interSchemeId.expDate = data.expDate
    state.interScheme.interSchemeId.createdBy = data.createdBy
    state.interScheme.interSchemeId.createdDate = data.createdDate
    state.interScheme.interSchemeId.modifiedBy = data.modifiedBy
    state.interScheme.interSchemeId.modifiedDate = data.modifiedDate
  }
}

const actions = {
  async interSchemeInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.interSchemeManagement
    commit(INTERSCHEME_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(INTERSCHEME_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(INTERSCHEME_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
